import Api from '../api'
export default ({

  state: {
    accountHeadLists: [],
    accountHeadDropList: [],
    accountSubHeadDropList: [],
    natureList: [],
    accountHeadDropListByNature: [],
    bankDetailLists: [],
    accountSubHeadLists: [],
    accountSubHeadChildLists: []
  },
  mutations: {
    ADD_ACCOUNT_HEAD (state, accountHeadLists) {
      let accountHeadList = state.accountHeadLists.concat(accountHeadLists)
      state.accountHeadLists = accountHeadList
      state.accountHeadDropList = accountHeadList
      state.accountHeadDropListByNature = accountHeadList
    },
    SET_ACCOUNT_HEAD_LIST (state, accountHeadList) {
      state.accountHeadLists = accountHeadList
    },
    SET_ACCOUNT_NATURE_LIST (state, natureList) {
      state.natureList = natureList
    },
    DELETE_ACCOUNT_HEAD (state, accountId) {
      let accountHead = state.accountHeadLists.filter(a => a.id !== accountId.id)
      state.accountHeadLists = accountHead
    },
    DELETE_SUB_ACCOUNT_HEAD (state, subAccId) {
      let subAccountHead = state.accountSubHeadLists.filter(a => a.id !== subAccId.id)
      state.accountSubHeadLists = subAccountHead
    },
    SET_ACCOUNT_SUB_HEAD_LIST (state, accountSubHeadList) {
      state.accountSubHeadLists = accountSubHeadList
    },
    SET_ACCOUNT_SUB_CHILD_HEAD_LIST (state, accountSubHeadChildList) {
      state.accountSubHeadChildLists = accountSubHeadChildList
    },
    ACCOUNT_SUBHEAD_DROPLIST(state, accountSubHead) {
      state.accountSubHeadDropList = accountSubHead
    },
    ACCOUNT_HEAD_DROPLIST(state, accountHead) {
      state.accountHeadDropList = accountHead
    },
    ACCOUNT_HEAD_DROPLIST_BY_NATURE(state, accountHeadByNature) {
      state.accountHeadDropListByNature = accountHeadByNature
    },
    SET_BANK_DETAIL_LIST (state, bankDetailList) {
      state.bankDetailLists = bankDetailList
    },
    ADD_ACCOUNT_SUB_HEAD (state, accountSubHeadLists) {
      let accountSubHeadList = state.accountSubHeadLists.concat(accountSubHeadLists)
      state.accountSubHeadLists = accountSubHeadList
      state.accountSubHeadDropList = accountSubHeadList
    },
    ADD_BANK_DETAIL (state, bankDetailLists) {
      if (state.bankDetailLists.length > 0) {
        let bankDetailList = state.bankDetailLists.concat(bankDetailLists)
        state.bankDetailLists = bankDetailList
      } else {
        state.bankDetailLists = [].concat(state.bankDetailLists, bankDetailLists)
      }
    },
    DELETE_BANK_DETAIL (state, bankDetailId) {
      let bankDetail = state.bankDetailLists.filter(a => a.id !== bankDetailId.id)
      state.bankDetailLists = bankDetail
    },
    UPDATE_ACCOUNTHEAD (state, updatedAccountHead) {
      state.accountHeadLists = state.accountHeadLists.map(accountHead => accountHead.id !== updatedAccountHead.id ? accountHead : {...accountHead, ...updatedAccountHead})
    },
    UPDATE_SUB_ACCOUNTHEAD(state, updatedSubAccountHead) {
      state.accountSubHeadLists = state.accountSubHeadLists.map(accountSubHead => accountSubHead.id !== updatedSubAccountHead.id ? accountSubHead : {...accountSubHead, ...updatedSubAccountHead})
    },
    UPDATE_BANK_DETAILS(state, updateBankDetail) {
      state.bankDetailLists = state.bankDetailLists.map(bankDetail => bankDetail.id !== updateBankDetail.id ? bankDetail : {...bankDetail, ...updateBankDetail})
    }
  },
  actions: {
    async createAccountHead({commit}, accountHead) {
      let response = await Api.request('post', '/accountMaster/createAccountHead/' + this.state.organisationid + '/' + this.state.user.id + '', accountHead)
      let savedAccountHead = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_ACCOUNT_HEAD', savedAccountHead)
      }
      return response
    },
    async createAccountSubHead({commit}, accountSubHead) {
      let response = await Api.request('post', '/accountMaster/createSubAccountHead/' + this.state.organisationid + '/' + this.state.user.id, accountSubHead)
      let savedAccountSubHead = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_ACCOUNT_SUB_HEAD', savedAccountSubHead)
      }
      return response
    },
    async createBankDetail({commit}, bank) {
      let response = await Api.request('post', '/accountMaster/createBankDetails/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, bank)
      let savedBankDetail = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_BANK_DETAIL', savedBankDetail)
      }
      return response
      // return savedAccountHead
    },
    async loadAccountHeadList({commit}) {
      let response = await Api.request('get', '/accountMaster/accountHeadList/' + this.getters.organisationId, null)
      commit('SET_ACCOUNT_HEAD_LIST', response.data.data)
      return response
    },
    async loadAccountNatureList({commit}) {
      let response = await Api.request('get', '/accountMaster/accountNatureList', null)
      commit('SET_ACCOUNT_NATURE_LIST', response.data.data)
      return response
    },
    async deleteAccountHead({commit}, deleteRea) {
      let response = await Api.request('delete', '/accountMaster/deleteAccountHead/' + deleteRea.accountHeadId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let deletedAccountHead = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('DELETE_ACCOUNT_HEAD', deletedAccountHead)
      }
      return response
    },
    async deleteAccSubHead({commit}, deleteRea) {
      let response = await Api.request('delete', '/accountMaster/deleteAccountSubHead/' + deleteRea.accountSubHeadId + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let deleteSubAccHead = response.data.data
      commit('DELETE_SUB_ACCOUNT_HEAD', deleteSubAccHead)
      return response
    },
    async loadAccountSubHeadList({commit}) {
      let response = await Api.request('get', '/accountMaster/accountSubHeadList/' + this.state.organisationid, null)
      commit('SET_ACCOUNT_SUB_HEAD_LIST', response.data.data)
    },
    async loadAccountSubHeadChildList({commit}) {
      let response = await Api.request('get', '/accountMaster/accountSubHeadChildList/' + this.state.organisationid, null)
      commit('SET_ACCOUNT_SUB_CHILD_HEAD_LIST', response.data.data)
    },
    async loadBankDetailList({commit}) {
      let response = await Api.request('get', '/accountMaster/reportBankDetails/' + this.state.organisationid + '/' + this.state.fyId, null)
      commit('SET_BANK_DETAIL_LIST', response.data.data)
      return response
    },
    async deleteBankDetail({ commit }, deleteRea) {
      let resp = await Api.request('delete', '/accountMaster/deleteBankDetail/' + deleteRea.bankDetailId + '/' + this.state.fyId + '/' + deleteRea.deleteReason)
      let deleteBankDetails = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_BANK_DETAIL', deleteBankDetails)
      }
      return resp
    },
    async updateAccountHead({commit}, accountHead) {
      let resp = await Api.request('put', '/accountMaster/accountHead/' + accountHead.id, accountHead)
      commit('UPDATE_ACCOUNTHEAD', resp.data.data)
      return resp
    },
    async updateAccountSubHead({commit}, accountSubHead) {
      let resp = await Api.request('put', '/accountMaster/accountSubHead/' + accountSubHead.id, accountSubHead)
      commit('UPDATE_SUB_ACCOUNTHEAD', resp.data.data)
      return resp
    },
    async updateBankDetail({commit}, bank) {
      let resp = await Api.request('put', '/accountMaster/updateBankDetail/' + bank.id + '/' + this.state.fyId, bank)
      commit('UPDATE_BANK_DETAILS', resp.data.data)
      return resp
    },
    async accountSubHeadDropDown({commit}) {
      let resp = await Api.request('get', '/accountMaster/accountSubHeadDropDownList/' + this.state.organisationid, null)
      commit('ACCOUNT_SUBHEAD_DROPLIST', resp.data.data)
      return resp
    },
    async accountSubHeadChildDropDown({commit}) {
      let resp = await Api.request('get', '/accountMaster/accountSubHeadChildDropDownList/' + this.state.organisationid, null)
      commit('ACCOUNT_SUBHEAD_DROPLIST', resp.data.data)
      return resp
    },
    async accountSubHeadDropDownByNature({commit}, natureId) {
      let resp = await Api.request('get', '/accountMaster/accountSubHeadDropDownListByNatureId/' + this.state.organisationid + '/' + natureId, null)
      commit('ACCOUNT_SUBHEAD_DROPLIST', resp.data.data)
      return resp
    },
    async accountHeadDropDown({commit}) {
      let resp = await Api.request('get', '/accountMaster/accountHeadDropDownList/' + this.state.organisationid, null)
      commit('ACCOUNT_HEAD_DROPLIST', resp.data.data)
      return resp
    },
    async accountHeadDropDownByNature({commit}, natureId) {
      let resp = await Api.request('get', '/accountMaster/accountHeadDropDownListByNatureId/' + this.state.organisationid + '/' + natureId, null)
      commit('ACCOUNT_HEAD_DROPLIST_BY_NATURE', resp.data.data)
      return resp
    }
  },
  getters: {
  }
})



// WEBPACK FOOTER //
// ./src/store/accountHead.js